"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deletedMark = void 0;
// We will put this thing in a field in
// order to consider it deleted
const deletedMark = '__rhfa_deleted';
exports.deletedMark = deletedMark;